/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { Shield } from 'lucide-react';
import PageBackButton from '../../components/PageBackButton';
import ThemeBuilder from './ThemeBuilder';

const AdminSettingsPage = () => {
  return (
    <div className="p-3 sm:p-4 md:p-6 lg:p-8 max-w-6xl mx-auto">
      {/* Page header */}
      <div className="flex items-center gap-3 mb-6 sm:mb-8">
        <PageBackButton label="Back to Settings" to="/settings" preferHistory={false} hideLabelOnMobile />
        <div className="p-2 rounded-lg bg-primary/10 text-primary">
          <Shield className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-textPrimary">
            Theme
          </h1>
          <p className="text-sm text-textSecondary">
            Manage shared theme settings and appearance
          </p>
        </div>
      </div>

      {/* Settings sections */}
      <div className="space-y-8">
        <ThemeBuilder />

        {/* Future admin sections placeholder */}
        {/* <UserManagement /> */}
        {/* <PlatformConfig /> */}
      </div>
    </div>
  );
};

export default AdminSettingsPage;
